import styled from 'styled-components';
import ds from 'designsystem';

const OrderedList = styled.ol`
  line-height: ${ds.get('type.lineHeight.s')};
`;

export default OrderedList;



// WEBPACK FOOTER //
// ./src/elements/OrderedList.js